import { useMapsLibrary } from '@vis.gl/react-google-maps';
import { SearchIcon } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from '@cold-ambulance/shadcn';

export function SearchPlaces({
  onChange,
  className,
}: {
  className?: string;
  onChange: (
    place: Omit<google.maps.places.PlaceResult, 'geometry' | 'place_id'> & {
      place_id: string;
      geometry: Omit<google.maps.places.PlaceGeometry, 'location'> & {
        location: google.maps.LatLng;
      };
    },
  ) => void;
}) {
  const { t } = useTranslation();
  const inputRef = useRef<HTMLInputElement>(null);
  const placesLib = useMapsLibrary('places');

  useEffect(() => {
    if (!placesLib || !inputRef.current) return;
    const ac = new placesLib.Autocomplete(inputRef.current, {
      componentRestrictions: { country: ['sa'] },
      strictBounds: true,
      fields: ['place_id', 'geometry', 'formatted_address', 'name'],
      types: ['establishment', 'geocode'],
    });

    ac.addListener('place_changed', () => {
      const p = ac.getPlace();
      if (!p || !p.place_id || !p.geometry || !p.geometry.location) return;
      onChange({
        ...p,
        place_id: p.place_id,
        geometry: {
          ...p.geometry,
          location: p.geometry.location,
        },
      });
    });
  }, [placesLib]);

  return (
    <InputGroup className={className}>
      <InputGroupInput ref={inputRef} placeholder={t('requests.searchLocation')} />
      <InputGroupAddon>
        <SearchIcon />
      </InputGroupAddon>
    </InputGroup>
  );
}
